import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CierreSemanalService } from 'app/infrastructure/services/catalog/cierre-semanal.service';
import Swal from 'sweetalert2';
import {
  FormBuilder,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DatesService } from 'app/infrastructure/services/alpura/dates.service';
import { environment } from 'environments/environment';
import { UtilInformationService } from '../../../services/utils/dates.service';
import { LoaderService } from '@infrastructure/shared/theme/loader/loader.service';

@Component({
  selector: 'app-cierre-semanal',
  templateUrl: './cierre-semanal.component.html',
  styleUrls: ['./cierre-semanal.component.scss'],
  providers: [CierreSemanalService, LoaderService, UtilInformationService],
})
export class CierreSemanalComponent implements OnInit {
  guardarFG: FormGroup = this.formBuilder.group({
    idDateCierre: ['', [Validators.required]],
  });
  isCierreSem = false;

  public panelInfo: any = {};
  ListaSemanas: String[] = [];
  public anio: any = ' ';

   cerrando=false;

  constructor(
    private formBuilder: FormBuilder,
    public _cierreSem: CierreSemanalService,
    private _datesServ: DatesService,
    private loader: LoaderService,
    private utilInformationService: UtilInformationService,
    private http: HttpClient
  ) {
    this.setDates();
  }

  ngOnInit(): void {}

  activaCheckSemanal(event: any) {
    const isChecked = event.target.checked;
    this.isCierreSem = isChecked;
  }

  cerrarSemana() {
    this.isCierreSem = true;
    let form: any = this.guardarFG.value;
    let body = {
      ejercicio: this.panelInfo.year,
      semana: this.panelInfo.week,
      isCierreSem: this.isCierreSem,
      fecha: form.idDateCierre,
    };

    this.loader.setLoading(true, 'Realizando cierre semanal');
    this.cerrando = true;
    this._cierreSem.cierreSemanal(body).subscribe(
      async (res: any) => {
    this.cerrando = false;
        this.loader.setLoading(false);
        if (res.isSuccess) {
          Swal.fire({
            icon: 'success',
            title: 'Cierre correcto',
            text: res.message,
            showConfirmButton: true,
          });
        } else {
          Swal.fire({
            icon: 'warning',
            html: res.message,
          });
        }
      },
      (error) => {
    this.cerrando = false;
        this.loader.setLoading(false);
        Swal.fire({
          icon: 'warning',
          html: `<b>Ocurrió un error al cerrar semana</b><br><br><em class='fa fa-info-circle'></em>&nbsp;`,
          title: 'Sin datos para filtro',
        });
      }
    );
  }

  private setDates() {
    this._datesServ.getCurrentDate().subscribe(
      async (resp: any) => {
        this.panelInfo.currentDate = new Date(resp);
        this.panelInfo.year = new Date(resp).getFullYear();
        this._datesServ.getCurrentWeek().subscribe(
          async (resp: any) => {
            this.panelInfo.week = resp;
            this.updateDates();
          },
          (error) => {
            console.error('Error al invocar el servicio de fechas Week.');
          }
        );
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Ocurrió un error',
          html: `<b>ERR00</b><br><br><em class='fa fa-info-circle'></em>&nbsp; Al invocar el servicio de fechas Week.`,
        });
      }
    );
  }

  public updateDates() {
    if (!!this.panelInfo.year && !!this.panelInfo.week) {
      this.utilInformationService
        .getDataFromDate(this.panelInfo.year, this.panelInfo.week)
        .subscribe(
          (response) => {
            const element = response;

            this.panelInfo.diaInicio = new Date(element.startDate)
              .toISOString()
              .slice(0, 10);
            this.panelInfo.diaFin = new Date(element.endDate)
              .toISOString()
              .slice(0, 10);

            // this.guardarFG
            //   .get('diaInicio')
            //   ?.patchValue(this.panelInfo.diaInicio);
            // this.guardarFG.get('diaFin')?.patchValue(this.panelInfo.diaFin);
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Ocurrió un error',
              text: `No se pudo recuperar las semanas`,
            });
          }
        );
    }
  }

  fillWeeks() {
    this.ListaSemanas.length = 0;
    let anio = this.panelInfo.year;
    let i = 0;
    let semanas: any;

    if (anio) {
      this._datesServ.getWeeksByYear(anio).subscribe(
        (response) => {
          semanas = response;
          for (i = 1; i <= semanas; i++) {
            this.ListaSemanas.push(i.toString());
          }
        },
        (error) => {
          Swal.fire({
            icon: 'error',
            title: 'Ocurrió un error',
            html: `<b>ERR00</b><br><br><em class='fa fa-info-circle'></em>&nbsp; Al ejecutar el servicio`,
          });
        }
      );
    }
  }

  selectWeek(): void {
    let datos_fecha = this.panelInfo.year + '/' + this.panelInfo.week;
    let url = environment.getDataFromDate + datos_fecha;
    this.http.get(url).subscribe((response: any) => {
      const fechaDelDate = response.startDate;
      const fechaAlDate = response.endDate;
      this.panelInfo.diaInicio = fechaDelDate.substring(0, 10);
      this.panelInfo.diaFin = fechaAlDate.substring(0, 10);
      this.guardarFG
        .get('idDateCierre')
        ?.setValue(fechaAlDate.substring(0, 10));
    });
  }
}
